<header>

    <app-skip-to-content></app-skip-to-content>
    <!--** Main header row **-->
    <div class="header-row ireland">
        
        <a href="https://www.ireland.ie/en/" role="link" aria-label="Ireland.ie" class="header__logo-wrapper">
            <img alt="Ireland Logo reverse white" class="header__logo" height="36"
                src="https://assets.ireland.ie/images/Ireland_logo_91x36.original.png" width="91">
        </a>
    </div>
    <div class="header-row">
        <div class="content-wrap">
            <div class="header-title ">

                <a href="https://www.ireland.ie/en/dfa/passports/urgent-appointment/" class="header-link__home" title="Go to Site Homepage">
                    <img class="header-title__logo header-title__logo--small"
                        alt="The Department of Foreign Affairs and Trade, Ireland"
                        src="./assets/images/Foreign-Affairs-and-Trade-White-80.png">
                    <img class="header-title__logo header-title__logo--large"
                        alt="The Department of Foreign Affairs and Trade, Ireland"
                        src="./assets/images/Foreign-Affairs-and-Trade-White-80.png">

                </a>
            </div>

            <div class="secondary-navigation">
                <ul class="secondary-nav-nav">

                    <li class="en lang-switcher secondary-nav-link" *ngIf="translate.currentLang ==  'ie'">
                        <a tabindex="0" (click)='translate.use("en")'>{{ 'MAIN_PAGE.LANGUAGE_SWITCH' | translate }}</a>
                    </li>

                    <li class="ie lang-switcher secondary-nav-link" *ngIf="translate.currentLang ==  'en'">
                        <a tabindex="0" (click)='translate.use("ie")'>{{ 'MAIN_PAGE.LANGUAGE_SWITCH' | translate }}</a>
                    </li>

                    <li class="secondary-nav-link"><a href="https://www.dfa.ie/about-us/who-we-are/our-ministers/"
                            target='_blank' title="Our Ministers">{{ 'MAIN_PAGE.OUR_MINISTERS' | translate }}</a></li>

                    <li class="secondary-nav-link"><a href="https://www.dfa.ie/embassies/" target='_blank'
                            title="DFA home">{{ 'MAIN_PAGE.EMBASSIES' | translate}}</a></li>
                    <li class="secondary-nav-link"><a href="https://www.dfa.ie/about-us/contact-us/" target='_blank'
                            title="DFA home">{{ 'MAIN_PAGE.CONTACT_US' | translate}}</a></li>
                </ul>
            </div>

            <!-- Uncomment for SVG icons -->
            <div class="header-navigation__mobile">
                <div class="header-navigation__mobile-menu" [ngClass]="{
                    'active': mobileMenuOpen
                  }" data-target="mobile-nav">
                    <a href="javascript:void(0)" title="Show main menu" (click)="toggleMobileMenu()">
                        <div class="header-navigation__mobile-icon ">
                            <div class="dfa-svg-icon header-navigation__mobile-icon__menu">
                                <div class="material-icons menu-icon">menu</div>
                            </div>
                            <div class="dfa-icon-label">Menu</div>
                        </div>

                    </a>
                </div>
            </div>

        </div>
        <!-- // .wrap -->

    </div>
    <!-- // .header-row -->

    <!--** Desktop and Mobile navigation drop-down, switches to desktop @  > 996px **-->
    <div class="main-nav-row" id="mobile-nav">
        <div class="content-wrap">
            <nav attr.aria-label="Headfer navigation">
                <div class="main-nav">

                    <ul class="main-nav-list">
                        <li class="main-nav-list__dropdown">
                            <a href="https://www.dfa.ie/passportonline/" target='_blank'
                                attr.aria-label="{{'MAIN_PAGE.HOME' | translate}}">
                                {{'MAIN_PAGE.HOME' | translate}}
                            </a>
                        </li>
                        <li class="main-nav-list__dropdown">
                            <a target="_blank"
                                href="https://www.dfa.ie/passports-citizenship/top-passport-questions/photo-guidelines/"
                                attr.aria-label="{{'MAIN_PAGE.PHOTO_GUIDELINES' | translate}}">
                                {{'MAIN_PAGE.PHOTO_GUIDELINES' | translate}}
                            </a>
                        </li><!-- // .main-nav-list > li -->
                        <li class="main-nav-list__dropdown">
                            <a target="_blank" href="https://www.dfa.ie/passports/questions/faqs/"
                                attr.aria-label="{{'MAIN_PAGE.FAQ' | translate}}">
                                {{'MAIN_PAGE.FAQ' | translate}}
                            </a>
                        </li><!-- // .main-nav-list > li -->
                        <li id="_uiLinkPrivacyPolicy">
                            <a target="_blank" href="https://www.dfa.ie/about-us/our-commitments/privacy-policy/"
                                attr.aria-label="{{'MAIN_PAGE.PRIVACY_POLICY' | translate}}">
                                {{'MAIN_PAGE.PRIVACY_POLICY' | translate}}
                            </a>
                        </li>
                    </ul>

                    <ul class="mobile-nav__lang-switchers mobile-secondary-nav-nav">
                        <li tabindex="0" class="en lang-switcher secondary-nav-link"
                            *ngIf="translate.currentLang ==  'ie'">
                            <a role="button"
                                (click)='translate.use("en")'>{{ 'MAIN_PAGE.LANGUAGE_SWITCH' | translate }}</a>
                        </li>

                        <li tabindex="0" class="ie lang-switcher secondary-nav-link"
                            *ngIf="translate.currentLang ==  'en'">
                            <a role="button"
                                (click)='translate.use("ie")'>{{ 'MAIN_PAGE.LANGUAGE_SWITCH' | translate }}</a>
                        </li>
                    </ul>

                    <ul class="mobile-secondary-nav-nav">
                        <li class="mobile-secondary-nav-link"><a
                                href="https://www.dfa.ie/about-us/who-we-are/our-ministers/" target='_blank'
                                title="DFA home">{{'MAIN_PAGE.OUR_MINISTERS' | translate}}</a></li>

                        <li class="mobile-secondary-nav-link"><a href="https://www.dfa.ie/embassies/" target='_blank'
                                title="DFA home">{{'MAIN_PAGE.EMBASSIES' | translate}}</a></li>
                        <li class="mobile-secondary-nav-link"><a href="https://www.dfa.ie/about-us/contact-us/"
                                target='_blank' title="DFA home">{{'MAIN_PAGE.CONTACT_US' | translate}}</a></li>

                    </ul>
                    <!-- // .mobile-secondary-nav-nav -->
                </div><!-- // .main-nav -->
            </nav>
        </div><!-- // .content-wrap -->
    </div>
</header>